import React, { useState, useEffect, useMemo } from 'react';
import './home.css';
import logo from '../../assets/images/Pathways_Logo.png';
import XLSX from 'xlsx-js-style';
import { useQuery, useMutation } from '@apollo/client';
import { v4 as uuidv4 } from 'uuid';
import { Sofa } from 'lucide-react';
import { listUsers, listOutreachInventories } from '../../graphql/queries';
import { createOutreachInventory, updateOutreachInventory, deleteOutreachInventory } from '../../graphql/mutations';
import { ToastContainer, toast } from 'react-toastify';
import useFilteredData from '../../components/layout/useFilteredDate';
import SearchBar from '../../components/layout/SearchBar';
import { capitalize } from '../../components/common/capitalize';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import logo2 from '../../assets/images/BCH Logo Final.png';


const Outreach_Home = () => {

    const [resources, setResources] = useState([]);
    const [showList, setShowList] = useState(false);
    const { data: userData } = useQuery(listUsers);
    const [userSearch, setUserSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [nextToken, setNextToken] = useState(null);
    const [selectedResource, setSelectedResource] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('');
    const [customDeviceTypes, setCustomDeviceTypes] = useState([]);
    const [showBrokenOnly, setShowBrokenOnly] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: 'tagid',
        direction: 'ascending',
    });
    const [newOutreach, setNewOutreach] = useState({
        id: '',
        tagid: '',
        deviceType: '',
        purchase_date: '',
        purchasePrice: '',
        placeOfPurchase: '',
        location: '',
        assignment_date: '',
        available: '',
        team: '1', // I am using it for quantity
        description: '',
        condition: '',
        userId: null,

    });

    const { data, fetchMore } = useQuery(listOutreachInventories, {
        variables: { limit: 100 },
    });

    const [addOutreach] = useMutation(createOutreachInventory, {
        refetchQueries: [{ query: listOutreachInventories, variables: { limit: 100 } }]
    });
    const [removeOutreach] = useMutation(deleteOutreachInventory, {
        refetchQueries: [{ query: listOutreachInventories, variables: { limit: 100 } }]
    });

    const [updOutreach] = useMutation(updateOutreachInventory, {
        refetchQueries: [{ query: listOutreachInventories, variables: { limit: 100 } }]
    });

    const clearResource = () => {
        setNewOutreach({
            id: '',
            tagid: '',
            deviceType: '',
            purchase_date: '',
            purchasePrice: '',
            placeOfPurchase: '',
            location: '',
            assignment_date: '',
            available: '',
            team: '1',
            description: '',
            condition: '',
            userId: null,
        });
    };

    //------Filtered General----------------
    //Filtro de Outreach empleando el componente useFilteredData
    const filteredResources = useFilteredData(resources || [], searchTerm, sortConfig, searchField, userData?.listUserFixes?.items, startDate, endDate);

    useEffect(() => {
        const fetchAllOutreach = async () => {
            let allOutreach = [];
            let currentNextToken = null;

            do {
                const { data } = await fetchMore({
                    variables: { limit: 100, nextToken: currentNextToken },
                });

                allOutreach = [...allOutreach, ...data.listOutreachInventories.items];
                currentNextToken = data.listOutreachInventories.nextToken;
            } while (currentNextToken);

            setResources(allOutreach);

            setNextToken(currentNextToken);
        };

        if (data) {
            fetchAllOutreach();
        }
    }, [data, fetchMore]);



    //*-------------- Save New Device Type----------------------
    useEffect(() => {
        const savedCustomTypes = localStorage.getItem("customDeviceTypes");
        if (savedCustomTypes) {
            setCustomDeviceTypes(JSON.parse(savedCustomTypes));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem("customDeviceTypes", JSON.stringify(customDeviceTypes));
    }, [customDeviceTypes]);

    const handleResetCustomDeviceTypes = () => {
        if (window.confirm("Are you sure you want to remove all custom device types?")) {
            localStorage.removeItem("customDeviceTypes");
            setCustomDeviceTypes([]);
            toast.info("Custom device types cleared.");
        }
    };

    const normalizeUserId = (val) => (val && val.trim() !== "" ? val.trim() : null);
    //------ Handle Add and Update------
    const handleAddResource = async (e) => {
        e.preventDefault();

        const isEditing = selectedResource && selectedResource.id;
        const res = isEditing ? selectedResource : newOutreach;

        // ✅ Detecta si se eligió "Other"
        const finalDeviceType =
            (res.deviceType === "Other" ? res.customDeviceType : res.deviceType) || "Unknown";
        if (
            finalDeviceType &&
            !customDeviceTypes.includes(finalDeviceType) &&
            ![
                "Wagon", "Chair", "Weights", "Table", "Canopy",
                "Stand Up Banner-Family", "Stand Up Banner-Enroll Now",
                "Stand Up Banner-Medicaid", "Retractable banner",
                "Tripod stand", "Stand up banner A", "Tablecloth",
                "Pullout Banner", "Kids Table w/4chairs", "Hanging Banner",
                "Sunshade side Wall", "Adjustable Laptop Rise", "Monitor stand",
                "Small Fan", "A-Frame", "A-Frame Inserts", "Flag", "Stamper", "Other"
            ].includes(finalDeviceType)
        ) {
            setCustomDeviceTypes((prev) => [...prev, finalDeviceType]);
        }

        const resourceToSave = {
            ...res,
            deviceType: finalDeviceType,
            assignment_date: res.assignment_date
                ? new Date(res.assignment_date).toISOString().split("T")[0]
                : null,
            purchase_date: res.purchase_date
                ? new Date(res.purchase_date).toISOString().split("T")[0]
                : null,
            purchasePrice: res.purchasePrice !== '' && res.purchasePrice !== null
                ? parseFloat(res.purchasePrice)
                : 0,
            userId: normalizeUserId(res.userId),
        };

        delete resourceToSave.customDeviceType;
        delete resourceToSave.user;

        // Validate that the tagid is unique (except if it is "No tag")
        if (
            resourceToSave.tagid?.toLowerCase() !== "no tag" &&
            resources.some(
                (r) =>
                    r.tagid?.trim().toLowerCase() === resourceToSave.tagid?.trim().toLowerCase() &&
                    r.id !== resourceToSave.id // Ignora si es el mismo recurso al editar
            )
        ) {
            toast.warning("The Tag ID must be unique unless it's 'No tag'.");
            return;
        }



        try {
            if (isEditing) {
                // UPDATE
                console.log("resourceToSave", resourceToSave)
                const cleanResourceForUpdate = (resource) => {
                    const {
                        __typename,
                        user,
                        ...cleaned
                    } = resource;

                    return cleaned;
                };

                const cleanedResource = cleanResourceForUpdate(resourceToSave);
                await updOutreach({ variables: { input: cleanedResource } });
                setResources((prev) =>
                    prev.map((r) => (r.id === res.id ? resourceToSave : r))
                );
                toast.success("Resource updated successfully.");
            } else {
                // CREATE
                const userIdClean = res.userId && res.userId.trim() !== "" ? res.userId : null;

                const newItem = { ...resourceToSave, id: uuidv4() };

                const variables = { input: newItem };

                if (userIdClean) {
                    variables.userId = userIdClean;
                }

                await addOutreach({ variables });

                setResources((prev) => [...prev, newItem]);
                toast.success("A new resource was successfully added.");
            }

            setSelectedResource(null);
            clearResource();
            e.target.reset();
        } catch (err) {
            console.error("Error saving resource:", err);
            toast.error("Error saving the resource.");
        }
    };

    ///---------------- HandleInputChange--------------
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (selectedResource) {
            setSelectedResource((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setNewOutreach((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    ///---------------- HandleDelete--------------
    const handleDelete = async (res) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this resource?");
        if (!confirmDelete) return;

        if (res.id) {
            try {
                await removeOutreach({ variables: { input: { id: res.id } } });
                setResources((prev) => prev.filter((e) => e.id !== res.id));
                toast.success('The Resource was removed successfully.');
            } catch (error) {
                console.error("Error deleting from DB:", error);
                toast.error("Failed to delete res. Try again.");
            }
        }
    };

    //-------------- HandleEdit----------

    const handleEditResource = (res) => {
        setSelectedResource({
            ...res,
            purchase_date: res.purchase_date || '',
            assignment_date: res.assignment_date || '',
            userId: res.userId || res.user?.id || '', // si usas relacion con user
        });
    };

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig?.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    ///---------------- Navigators--------------
    const navigatorOptions = userData?.listUserFixes?.items
        ?.filter((u) => u && u.first_name && u.last_name)
        ?.map((u) => ({
            id: u.id,
            name: `${u.first_name.charAt(0).toUpperCase() + u.first_name.slice(1).toLowerCase()} 
           ${u.last_name.charAt(0).toUpperCase() + u.last_name.slice(1).toLowerCase()}`
        }))
        ?.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })) || [];


    //--------------------Excel ---------------------

    const exportToExcel = (data, fileName = "Outreach_Resources.xlsx") => {

        const exportData = data.map(res => ({
            "Inv. Tag ID": res.tagid || '',
            "Device Type": res.deviceType || '',
            "Date Purchased": res.purchase_date || '',
            "Purchase Price": res.purchasePrice || 0,
            "Place of Purchase": res.placeOfPurchase || '',
            "Location": res.location || '',
            "Date Assigned": res.assignment_date || '',
            "Employee Assigned": `${res.user?.first_name || ''} ${res.user?.last_name || ''}`.trim(),
            "Description": res.description || '',
            "Condition": res.condition || '',
            "Quantity": res.team || ''
        }));
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        worksheet["!cols"] = [
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 30 },
            { wch: 30 },
            { wch: 30 },
            { wch: 20 },
            { wch: 30 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
        ];


        const headerStyle = {
            font: {
                bold: true,
                sz: 16,
                color: { rgb: "FFFFFF" }
            },
            fill: { fgColor: { rgb: "0070C0" } },
        };

        const headerKeys = Object.keys(exportData[0]);
        headerKeys.forEach((_, colIndex) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            if (!worksheet[cellAddress]) return;
            worksheet[cellAddress].s = headerStyle;
        });



        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Outreach");
        XLSX.writeFile(workbook, fileName);
    };

    //----------------PDF--------------------------

    const isValidUser = () => {
        return resources.some(res => {
            if (!res.user) return false;
            const fullName = `${res.user.first_name} ${res.user.last_name}`.toLowerCase();
            return fullName.includes(searchTerm.toLowerCase());
        });
    };


    const handleDownloadPDF = () => {
        const userFiltered = visibleResources.filter(res => {
            const fullName = `${res.user?.first_name || ""} ${res.user?.last_name || ""}`.toLowerCase();
            return fullName.includes(searchTerm.toLowerCase());
        });

        if (userFiltered.length === 0) {
            alert("Please select a valid user.");
            return;
        }

        const doc = new jsPDF();

        const image = new Image();
        image.src = logo2;

        image.onload = () => {
            doc.addImage(image, 'PNG', 150, 10, 40, 15); // (x, y, width, height)


            doc.setFontSize(14);
            doc.text(`Equipment Check Out`, 14, 15);
            const navigatorName = `${capitalize(userFiltered[0]?.user?.first_name) || ""} ${capitalize(userFiltered[0]?.user?.last_name) || ""}`;
            doc.text(`Navigator: ${navigatorName}`, 14, 22);

            const marginLeft = 14;

            autoTable(doc, {
                startY: 25,
                head: [["Tag ID", "Device Type", "Quantity", "Assignment Date", "Return in Good condition (Y/N)"]],
                body: userFiltered.map(item => [
                    item.tagid || "N/A",
                    item.deviceType || "N/A",
                    item.team || "N/A",
                    item.assignment_date || "N/A",
                    ""
                ])
            });
            const finalY = doc.lastAutoTable.finalY + 15;

            doc.setFontSize(12);
            doc.text(`Navigator Signature Check-out: ____________________`, marginLeft, finalY);
            doc.text(`Supervisor Signature Check-out: ____________________`, marginLeft, finalY + 10);

            doc.text(`Navigator Signature Check-in:  ____________________`, marginLeft, finalY + 20);
            doc.text(`Supervisor Signature Check-in:  ____________________`, marginLeft, finalY + 30);

            doc.text("Check-out Date: ____________", marginLeft, finalY + 40);
            doc.text("Check-in Date: ____________", marginLeft + 80, finalY + 40);


            doc.save(`Inventory_${navigatorName.replace(/\s+/g, '_')}.pdf`);
        };
    };


    //------ Broken---------------------
    const visibleResources = showBrokenOnly
        ? filteredResources.filter(res => res.condition?.toLowerCase() === "broken")
        : filteredResources;


    return (
        <div className="outreach-container">
            <header className="principal-container">
                <h1>Outreach Kit and Mobile Resources</h1>
                <div className="principal-logo-container" >

                    <img src={logo} alt="logo" className="principal-logo" />
                </div>
            </header>

            <ToastContainer position="top-center" autoClose={4000} hideProgressBar />
            <div className="principal-box">

                <section id2="all" className="principal-home-form">
                    <h2> <Sofa size={20} style={{ marginRight: "8px", verticalAlign: "middle" }} />Outreach Kit and Mobile Resources</h2>

                    <form className="resource-outreach" onSubmit={handleAddResource}>
                        <div className="outreach-grid">
                            <div className="outreach-group">
                                <label>Inv. Tag ID</label>
                                <input type="text" name="tagid"
                                    value={
                                        selectedResource ? selectedResource.tagid : newOutreach.tagid
                                    }
                                    onChange={handleInputChange} required />
                            </div>

                            <div className="outreach-group">
                                <label>Device Type</label>
                                <select name="deviceType"
                                    value={selectedResource ? selectedResource.deviceType : newOutreach.deviceType}
                                    onChange={handleInputChange} required>
                                    <option value="">Select Device Type</option>
                                    <option value="Wagon">Wagon</option>
                                    <option value="Chair">Chair</option>
                                    <option value="Weights">Weights</option>
                                    <option value="Table">Table</option>
                                    <option value="Canopy">Canopy</option>
                                    <option value="Stand Up Banner-Family">Stand Up Banner-Family</option>
                                    <option value="Stand Up Banner-Enroll Now">Stand Up Banner-Enroll Now</option>
                                    <option value="Stand Up Banner-Medicaid">Stand Up Banner-Medicaid</option>
                                    <option value="Retractable banner">Retractable banner</option>
                                    <option value="Tripod stand">Tripod stand</option>
                                    <option value="Stand up banner A">Stand up banner A</option>
                                    <option value="Tablecloth">Tablecloth</option>
                                    <option value="Pullout Banner">Pullout Banner</option>
                                    <option value="Kids Table w/4chairs">Kids Table w/4chairs</option>
                                    <option value="Hanging Banner">Hanging Banner</option>
                                    <option value="Sunshade side Wall">Sunshade side Wall</option>
                                    <option value="Adjustable Laptop Rise">Adjustable Laptop Rise</option>
                                    <option value="Monitor stand">Monitor stand</option>
                                    <option value="Small Fan">Small Fan</option>
                                    <option value="A-Frame">A-Frame</option>
                                    <option value="A-Frame Inserts">A-Frame Signs</option>
                                    <option value="Flag">Flag</option>
                                    <option value="Stamper">Stamper</option>

                                    {customDeviceTypes.map((type) => (
                                        <option key={type} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                    <option value="Other">Other</option>
                                </select>
                                {customDeviceTypes.length > 0 && (
                                    <button
                                        type="button"
                                        className="btn-reset"
                                        onClick={handleResetCustomDeviceTypes}
                                        style={{ marginTop: "8px" }}
                                    >
                                        Reset Custom Device Types
                                    </button>
                                )}

                                {(selectedResource?.deviceType === "Other" || newOutreach.deviceType === "Other") && (
                                    <input
                                        type="text"
                                        name="customDeviceType"
                                        placeholder="Enter device type"
                                        value={selectedResource ? selectedResource.customDeviceType || "" : newOutreach.customDeviceType || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                )}
                            </div>

                            <div className="outreach-group">
                                <label>Date Purchased</label>
                                <input type="date" name="purchase_date"
                                    value={selectedResource ? selectedResource.purchase_date : newOutreach.purchase_date}
                                    onChange={handleInputChange} />
                            </div>

                            <div className="outreach-group">
                                <label>Purchase Price</label>
                                <input type="number" step="0.01" min="0" name="purchasePrice"
                                    value={selectedResource ? selectedResource.purchasePrice : newOutreach.purchasePrice || null}

                                    onChange={handleInputChange} />
                            </div>

                            <div className="outreach-group">
                                <label>Place of Purchase</label>
                                <input type="text" name="placeOfPurchase"
                                    value={selectedResource ? selectedResource.placeOfPurchase : newOutreach.placeOfPurchase}
                                    onChange={handleInputChange} />
                            </div>

                            <div className="outreach-group">
                                <label>Location / Storage / Use</label>
                                <input type="text" name="location"
                                    value={selectedResource ? selectedResource.location : newOutreach.location}
                                    onChange={handleInputChange} required />
                            </div>

                            <div className="outreach-group">
                                <label>Date Assigned</label>
                                <input type="date" name="assignment_date"
                                    value={selectedResource ? selectedResource.assignment_date : newOutreach.assignment_date}
                                    onChange={handleInputChange} />
                            </div>

                            <div className="outreach-group">
                                <label>Navigator Assigned To:</label>
                                <select
                                    name="userId"
                                    value={selectedResource ? selectedResource.userId : newOutreach.userId}
                                    onChange={handleInputChange}
                                >

                                    <option value="">----</option>
                                    {navigatorOptions.length > 0 ? (
                                        navigatorOptions.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.name}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="" disabled>No employees available</option>
                                    )}


                                </select>
                            </div>
                            <div className="outreach-group">
                                <label>Available:</label>
                                <select name="available" placeholder="available"
                                    value={selectedResource ? selectedResource.available : newOutreach.available}
                                    onChange={handleInputChange} required>
                                    <option value="" className="placeholder-option">Select Availability</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>

                                </select></div>
                            <div className="outreach-group">
                                <label>Condition - Cable / Accessories:</label>
                                <select name="condition" onChange={handleInputChange}
                                    value={selectedResource ? selectedResource.condition : newOutreach.condition}
                                    required>
                                    <option value="" className="placeholder-option">Select an option</option>
                                    <option value="use">Use</option>
                                    <option value="good">Good</option>
                                    <option value="broken">Broken</option>
                                    <option value="new">New</option>
                                    <option value="transfer">Transfer</option>
                                    <option value="lost">Lost</option>
                                    <option value="inv">Inventario</option>

                                </select></div>

                            <div className="outreach-group">
                                <label>Quantity</label>
                                <input type="text" name="team"
                                    value={selectedResource ? selectedResource.team : newOutreach.team}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                            handleInputChange(e);
                                        }
                                    }} />
                            </div>

                            <div className="outreach-group">
                                <label> Notes/Descripcion</label>
                                <textarea
                                    name="description"
                                    value={selectedResource ? selectedResource.description : newOutreach.description}
                                    onChange={handleInputChange}
                                    rows={2}
                                />
                            </div>


                        </div>

                        <div className="outreach-actions">
                            <button type="submit" className="add-resource-btn">
                                {selectedResource ? "✓ Update Resource" : "+ Add Resource"}
                            </button>

                            {selectedResource && (
                                <button
                                    type="button"
                                    className="add-resource-btn"
                                    onClick={() => setSelectedResource(null)}
                                >
                                    Cancel Edit
                                </button>
                            )}
                            <button type="button" className="view-resources-btn" onClick={() => {
                                setShowList(!showList);
                                setShowBrokenOnly(false);
                            }}>
                                {showList ? 'Hide Resource List' : 'View All Resources'}
                            </button>
                        </div>
                    </form>

                </section>

                {showList && (
                    <section id2="all" className="principal-home-form">

                        <div className="filter-controls">

                            <SearchBar searchTerm={searchTerm} onSearch={setSearchTerm} />
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}

                            />
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />

                            <button
                                type="button"
                                className="btn-primary"
                                onClick={() => setShowBrokenOnly(prev => !prev)}
                            >
                                {showBrokenOnly ? "Show All Resources" : "Show Broken Only"}
                            </button>



                            <button className="btn-primary" onClick={() => exportToExcel(visibleResources)}>
                                Export to Excel
                            </button>
                            <button
                                className="btn-primary"
                                disabled={!searchTerm || !isValidUser()}
                                onClick={handleDownloadPDF}
                            >
                                Download PDF to Check Out
                            </button>

                        </div>
                        <div className="submitted-table-scroll">
                            <table className="outreach-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th onClick={() => requestSort('tagid')}>Inv. Tag ID
                                            {sortConfig?.key === 'tagid' && (
                                                <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                            )}
                                        </th>
                                        <th onClick={() => requestSort('deviceType')}>Device Type
                                            {sortConfig?.key === 'deviceType' && (
                                                <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                            )}
                                        </th>
                                        <th onClick={() => requestSort('purchase_date')}>Date Purchased
                                            {sortConfig?.key === 'purchase_date' && (
                                                <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                            )}
                                        </th>
                                        <th onClick={() => requestSort('purchasePrice')}>Purchase Price {sortConfig?.key === 'purchasePrice' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>
                                        <th onClick={() => requestSort('placeOfPurchase')}>Place of Purchased {sortConfig?.key === 'placeOfPurchase' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>
                                        <th onClick={() => requestSort('location')}>Location
                                            {sortConfig?.key === 'location' && (
                                                <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                            )}
                                        </th>
                                        <th onClick={() => requestSort('assignment_date')}>Date Assigned
                                            {sortConfig?.key === 'assignment_date' && (
                                                <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                            )}
                                        </th>
                                        <th onClick={() => requestSort('userId')}>Navigator {sortConfig?.key === 'userId' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>
                                        <th onClick={() => requestSort('available')}>Available  {sortConfig?.key === 'available' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>
                                        <th onClick={() => requestSort('condition')}>Condition  {sortConfig?.key === 'condition' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>
                                        <th onClick={() => requestSort('team')}> Quantity  {sortConfig?.key === 'team' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>

                                        <th onClick={() => requestSort('description')}> Notes/Descripcion{sortConfig?.key === 'description' && (
                                            <span className={sortConfig.direction === 'ascending' ? 'sort-descending' : 'sort-ascending'} />
                                        )}</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleResources?.map((res, index) => (

                                        <tr key={index} onClick={() => handleEditResource(res)}>
                                            <td>{index + 1}</td>
                                            <td>{res.tagid}</td>
                                            <td>{res.deviceType}</td>
                                            <td>{res.purchase_date}</td>
                                            <td>{res.purchasePrice}</td>
                                            <td>{res.placeOfPurchase}</td>
                                            <td>{res.location}</td>
                                            <td>{res.assignment_date}</td>
                                            <td>
                                                {capitalize(res.user?.first_name) && capitalize(res.user?.last_name)
                                                    ? `${capitalize(res.user.first_name)} ${capitalize(res.user.last_name)}`
                                                    : "N/A"}
                                            </td>
                                            <td >{res.available ? 'Yes' : 'No'}</td>
                                            <td>{res.condition}</td>
                                            <td>{res.team}</td>
                                            <td>{res.description}</td>
                                            <td>
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); handleDelete(res, index) }}
                                                    className="view-map-btn"

                                                >
                                                    🗑️
                                                </button></td>

                                        </tr>

                                    ))}
                                </tbody>
                            </table>
                        </div></section>
                )}





            </div>
        </div >

    )


};

export default Outreach_Home;
